import { getCookie } from '../../util/getCookie';

export const getConsentDecision = () => {
  const noticeBehavior = getCookie('notice_behavior', document.cookie);
  const noticePreference = getCookie('notice_preferences', document.cookie);

  if (noticeBehavior === 'none') {
    return 2;
  }

  if (noticePreference) {
    return +noticePreference.replace(':', '');
  }

  if (!noticePreference && noticeBehavior === 'implied,eu') {
    return 'awaiting-user-response';
  }

  return null;
};
